<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					arrowLeft: {
						name: 'arrowLeft',
						defaultValue: false,
						defaultColor: false,
						defaultSize: false,
						callback: function () {
							vm.resources.arrowLeft.defaultValue = this.value;
							vm.resources.arrowLeft.defaultColor = this.valueColor;
							vm.resources.arrowLeft.defaultSize = this.valueSize;

							vm.element.internal_config.arrowLeft.active = this.value;
							vm.element.internal_config.arrowLeft.color = this.valueColor;
							vm.element.internal_config.arrowLeft.size = this.valueSize;
						},
					},
					arrowRight: {
						name: 'arrowRight',
						defaultValue: false,
						defaultColor: false,
						defaultSize: false,
						callback: function () {
							vm.resources.arrowRight.defaultValue = this.value;
							vm.resources.arrowRight.defaultColor = this.valueColor;
							vm.resources.arrowRight.defaultSize = this.valueSize;

							vm.element.internal_config.arrowRight.active = this.value;
							vm.element.internal_config.arrowRight.color = this.valueColor;
							vm.element.internal_config.arrowRight.size = this.valueSize;
						},
					},

					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					},
          maxWidth: {
            name: 'maxWidth',
            defaultValue: '500',
            min: '200',
            max: '768',
            labelDesc: 'max-width-tablet',
            callback: function () {
              vm.resources.maxWidth.defaultValue = this.value;
              vm.element.internal_config.maxWidth = this.value + 'px';

            },
          },
					width: {
						name: 'width',
						defaultValue: '150',
						min: '50',
						max: '800',
						labelDesc: 'width',
						callback: function () {
							vm.resources.width.defaultValue = this.value;
							vm.element.internal_config.width = this.value + 'px';
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},

					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.boxShadow = value;
						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},

				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;
				this.resources.width.defaultValue = parseInt(data.internal_config.width);
				this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

				this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;
				this.resources.border.defaultValue = data.internal_config.border;

				this.resources.arrowLeft.defaultValue = data.internal_config.arrowLeft.active;
				this.resources.arrowLeft.defaultColor = data.internal_config.arrowLeft.color;
				this.resources.arrowLeft.defaultSize = data.internal_config.arrowLeft.size;

				this.resources.arrowRight.defaultValue = data.internal_config.arrowRight.active;
				this.resources.arrowRight.defaultColor = data.internal_config.arrowRight.color;
				this.resources.arrowRight.defaultSize = data.internal_config.arrowRight.size;

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Line/Resources.vue